export const mailingLists = `
  query MailingLists {
    mailingLists {
      id
      name
      reportKey
      recipients {
        id
        name
        email
        type
        category
        org
      }
    }
  }
`;

export const createMailingList = `
  mutation CreateMailingList($name: String!, $reportKey: String!) {
    createMailingList(name: $name, reportKey: $reportKey) { id }
  }
`;

export const renameMailingList = `
  mutation RenameMailingList($id: String!, $name: String!) {
    renameMailingList(id: $id, name: $name) { id }
  }
`;

export const deleteMailingList = `
  mutation DeleteMailingList($id: String!) {
    deleteMailingList(id: $id)
  }
`;

export const addMailingListRecipient = `
  mutation AddMailingListRecipient($listId: String!, $input: MailingRecipientInput!) {
    addMailingListRecipient(listId: $listId, input: $input) {
      id
      name
      email
      type
      category
      org
    }
  }
`;

export const updateMailingListRecipient = `
  mutation UpdateMailingListRecipient($id: String!, $input: MailingRecipientInput!) {
    updateMailingListRecipient(id: $id, input: $input) { id }
  }
`;

export const removeMailingListRecipient = `
  mutation RemoveMailingListRecipient($listId: String!, $id: String!) {
    removeMailingListRecipient(listId: $listId, id: $id)
  }
`;
